



















import { Component , Vue } from 'vue-property-decorator';
@Component({
    props: {
        url: String,
    },
    watch: {
        '$route.query.requestType'() {
            const requestPanel = this as RequestMobile;
        },
        '$route.query.status'() {
            const requestPanel = this as RequestMobile;
        },
        '$route.path'(to, from) {
            if (!this.$route.params.id) {
                const requestPanel = this as RequestMobile;
            }
        },
    },
})
export default class RequestMobile extends Vue {
    private requestType: any = 'transportRequest';
    public mounted() {
        this.init();
    }
    private async init() {
        const requestType = this.$route.query.requestType;
        this.requestType = requestType ? requestType : 'transportRequest';
    }
}
